import React from 'react';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import { parseMessageWithLinks, timeStampToDigital } from '../utils/helpers';
import { LeftTail, RightTail } from '../icons/ChatBubbleTail';

const styles = {
  messageWrapper: {
    marginTop: '8px',
    marginBottom: '8px'
  },
  receivedMessageWrapper: {
    display: 'flex',
    alignItems: 'flex-start'
  },
  sentMessageWrapper: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-end'
  },
  messageBubbleTouchable: {
    maxWidth: '85%',
    minWidth: '140px',
    cursor: 'pointer',
    position: 'relative'
  },
  messageBubble: {
    padding: '12px',
    borderRadius: '12px',
    minHeight: '40px',
    position: 'relative',
    overflow: 'visible'
  },
  receivedMessage: {
    backgroundColor: '#E8E5E0',
    borderBottomLeftRadius: '2px'
  },
  sentMessage: {
    backgroundColor: '#e3f2fd',
    borderBottomRightRadius: '2px'
  },
  senderName: {
    fontSize: '12px',
    marginBottom: '4px',
    fontWeight: '600',
    color: '#090909'
  },
  messageText: {
    fontSize: '14px',
    lineHeight: '18px',
    color: '#000',
    margin: 0,
    whiteSpace: 'pre-wrap',
    wordWrap: 'break-word'
  },
  deletedbyMessageText: {
    fontSize: 10,
    fontStyle: 'italic',
    padding: 5,
    borderRadius: 4,
    backgroundColor: 'rgba(0, 0, 0, 0.05)',
    borderColor: 'rgba(0, 0, 0, 0.1)'
  },
  timeContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginTop: '8px'
  },
  editedLabel: {
    fontSize: '10px',
    color: '#090909',
    marginRight: '4px'
  },
  timeText: {
    fontSize: '10px',
    color: '#090909'
  },
  checkMarkContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginLeft: '3px'
  }
};

const ChatBubble = ({
  senderName,
  message,
  hidden,
  timestamp,
  markAsRead,
  isReceived,
  isEdited,
  children,
  onPress
}) => {
  return (
    <div
      style={{
        ...styles.messageWrapper,
        ...(isReceived ? styles.receivedMessageWrapper : styles.sentMessageWrapper)
      }}
    >
      <div
        style={styles.messageBubbleTouchable}
        onClick={(event) => {
          event.stopPropagation();
          onPress();
        }}
      >
        <div
          style={{
            ...styles.messageBubble,
            ...(isReceived ? styles.receivedMessage : styles.sentMessage)
          }}
        >
          <div style={styles.senderName}>{senderName}</div>

          {children}

          {message && hidden == 1 && isReceived ? (
            <s>
              <p style={styles.messageText}>{parseMessageWithLinks(message)}</p>
            </s>
          ) : (
            <p style={styles.messageText}>{parseMessageWithLinks(message)}</p>
          )}

          {hidden == 1 && (
            <p style={styles.deletedbyMessageText}>This message is deleted by the client.</p>
          )}

          <div style={styles.timeContainer}>
            {isEdited && <span style={styles.editedLabel}>Edited</span>}

            <span style={styles.timeText}>{timeStampToDigital(timestamp)}</span>

            {!isReceived && (
              <div style={styles.checkMarkContainer}>
                <DoneAllIcon
                  sx={{
                    fontSize: 16,
                    color: markAsRead ? '#34C759' : '#999'
                  }}
                />
              </div>
            )}
          </div>

          {isReceived ? <LeftTail /> : <RightTail />}
        </div>
      </div>
    </div>
  );
};

export { ChatBubble };
